export const NATIVE_CRASH_MESSAGE = 'Manually triggering crash in native code.';
export const WRONG_PLATFORM_NATIVE_CRASH_MESSAGE =
  'Native Sentry errors are not supported on non-native platforms';
